import { css } from '@emotion/react';
import { AppointmentAggregatesResponse } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { theme } from '@frontend/theme';
import { VIEW_KEYS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';
import { AppointmentConfirmationChart } from './upcoming-appointments/appointment-confirmation-chart';
import { ProspectPatientList } from './upcoming-appointments/prospect-patient-list';
import { UpcomingAppointmentsDataCards } from './upcoming-appointments/upcoming-appointments-data-cards';
import { AppointmentAnalyticsV2TableView } from './views/table-view';

interface Props {
  aggregatesData: AppointmentAggregatesResponse | undefined;
  aggregatesDataLoading: boolean;
}

export const UpcomingAppointmentsTab = (props: Props) => {
  const { aggregatesData, aggregatesDataLoading } = props;
  const { view } = useAppointmentAnalyticsV2ShallowStore('view');

  return (
    <div css={styles.tabContent}>
      {view === VIEW_KEYS.TABLE ? (
        <AppointmentAnalyticsV2TableView />
      ) : (
        <>
          <UpcomingAppointmentsDataCards
            aggregatesData={aggregatesData}
            aggregatesDataLoading={aggregatesDataLoading}
          />
          <AppointmentConfirmationChart />
          <ProspectPatientList />
        </>
      )}
    </div>
  );
};

const styles = {
  tabContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,
};
